import React from 'react';
import {useSelector} from "react-redux";

export default function () {
    const loading = useSelector(state => state.loading);

    function renderContent() {
        if (loading.loading_content) {
            return (
                <div className='preloader-content'>{loading.loading_content}</div>
            );
        }

        return null;
    }

    if (loading.active) {
        return (
            <div className="preloader-holder">
                <div className="preloader">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                {renderContent()}
            </div>
        );
    } else {
        return null;
    }
}
